import React from "react";
import { observer, Provider } from "mobx-react";
import StoriesStore from "../stores/StoriesStore";
import Pillars from "../components/Stories/Pillars";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

interface StoriesState {
  store: StoriesStore;
}

interface StoriesProps {
  baseName: string;
}

@observer
class Stories extends React.Component<StoriesProps, StoriesState> {
  constructor(props: StoriesProps) {
    super(props);

    this.state = {
      store: new StoriesStore()
    };
  }

  render() {
    const { store } = this.state;

    return (
      <Router basename={this.props.baseName}>
        <Provider store={store}>
          <Switch>
            <Route exact path="/" render={props => <Pillars store={store} {...props} />} />
            <Route
              path="/value"
              render={props => <Pillars store={store} {...props} selectedPillar={0} />}
            />
            <Route
              path="/technology"
              render={props => <Pillars store={store} {...props} selectedPillar={1} />}
            />
            <Route
              path="/infotainment"
              render={props => <Pillars store={store} {...props} selectedPillar={2} />}
            />
            <Route
              path="/style"
              render={props => <Pillars store={store} {...props} selectedPillar={3} />}
            />
            <Route
              path="/handling"
              render={props => <Pillars store={store} {...props} selectedPillar={4} />}
            />
          </Switch>
        </Provider>
      </Router>
    );
  }
}

export default Stories;
